import {
  ItemGroup,
  ItemGroupFormValue,
  PreviewItemGroupReq,
  PreviewItemGroupRes,
  QueryItemGroupListReq,
  Store,
} from './type';
import { doorClient, resolve, storeHomeV2Client } from 'services/api';

export const queryItemGroupList = (params: QueryItemGroupListReq) => {
  return doorClient.get<{
    itemGroup: ItemGroup[];
  }>('/item/v1/item_group_list', {
    params,
  });
};

export const createItemGroup = (data: ItemGroupFormValue) => {
  return doorClient.post('/item/v1/create_item_group', {
    itemGroup: data,
  });
};

export const updateItemGroup = (data: ItemGroupFormValue) => {
  return doorClient.put('/item/v1/update_item_group', {
    itemGroup: data,
  });
};

export const deleteItemGroup = (data: ItemGroup) => {
  return doorClient.post('/item/v1/delete_item_group', {
    itemGroup: data,
  });
};

export const duplicateItemGroup = (data: ItemGroup) => {
  return doorClient.post('/item/v1/duplicate_item_group', {
    itemGroup: data,
  });
};

export const previewItems = (data: PreviewItemGroupReq) => {
  return doorClient.post<PreviewItemGroupRes>('/item/v1/preview_item_group', data);
};

export const fetchStoresByDepts = (departmentIds: number[]) => {
  return resolve<Store[]>(
    storeHomeV2Client.post('/admin/list_dept_stores', {
      departmentIds,
    }),
  );
};
